import { SearchFilterBase } from '@aibees/elephant/feature/search-filters/types';
import { SearchType } from '@aibees/elephant/types';
import annualRevenueFilterConfig from './annual-revenue';
import companyInfoFilterConfig from './company-info';
import companySearchFilterConfig from './company-search';
import companyTypeFilterConfig from './company-type';
import employeeByDeptFilterConfig from './employee-by-dept';
import employeeSizeFilterConfig from './employee-size';
import enrichmentRequestFilterConfig from './enrichment-request';
import exportsRequestFilterConfig from './exports-request';
import foundedYearFilterConfig from './founded-year';
import fundingFilterConfig from './funding';
import headcountGrowthFilterConfig from './headcount-growth';
import industryFilterConfig from './industry';
import keywordsFilterConfig from './keywords';
import lablesFilterConfig from './labels';
import listsFilterConfig from './lists';
import locationFilterConfig from './location';
import locationsWorldwideFilterConfig from './locations-worldwide';
import operationLanguageFilterConfig from './operation-language';
import productAndServicesyFilterConfig from './product-and-services';
import recordsOwnershipFilterConfig from './recrods-ownership';
import relevancyFilterConfig from './relevancy';
import sicAndNaicsFilterConfig from './sic-and-naics';
import socialMediaFilterConfig from './social-media';
import socialMediaFollowersFilterConfig from './social-media-followers';
import technologiesFilterConfig from './technologies';

const filters: SearchFilterBase[] = [
  listsFilterConfig(SearchType.Company),
  exportsRequestFilterConfig(SearchType.Company),
  companyInfoFilterConfig(),
  companySearchFilterConfig(),
  employeeSizeFilterConfig(),
  locationFilterConfig(SearchType.Company),
  keywordsFilterConfig(SearchType.Company),
  industryFilterConfig(),
  sicAndNaicsFilterConfig(),
  productAndServicesyFilterConfig(),
  companyTypeFilterConfig(),
  technologiesFilterConfig(),
  employeeByDeptFilterConfig(),
  headcountGrowthFilterConfig(),
  fundingFilterConfig(),
  annualRevenueFilterConfig(),
  operationLanguageFilterConfig(),
  locationsWorldwideFilterConfig(),
  foundedYearFilterConfig(),
  socialMediaFilterConfig(SearchType.Company),
  socialMediaFollowersFilterConfig(SearchType.Company),
  lablesFilterConfig(SearchType.Company),
  recordsOwnershipFilterConfig(SearchType.Company),
  relevancyFilterConfig(),
  enrichmentRequestFilterConfig(SearchType.Company),
];

export default filters;
